import { FC, useRef, useEffect, CSSProperties } from 'react';

import { useTheme } from 'styled-components';

import { useScroll, useOutsideClick } from '@hooks/hooks';
import CustomIcon from '@components/utils/CustomIcon';
import { Info } from '@assets/icons/index';
import { RoomExpediaPriceDetailViewModel } from '@api/index';
import { Row } from '@components/formStyles';
import { getCurrencySymbol } from '@utils/utils';

import {
  FeeDetailsTooltip,
  FeeDetailsItem,
  FeeDetailsButton,
  FeeDetailsDueHotelLabel,
} from './DetailsStyle';

export interface FeeDetailsProps {
  openFeeDetails?: boolean;
  toggleOpenFeeDetails?: React.Dispatch<React.SetStateAction<boolean>>;
  feeDetails?: RoomExpediaPriceDetailViewModel;
  buttonStyle?: CSSProperties;
}

const FeeDetails: FC<FeeDetailsProps> = (props) => {
  const { palette } = useTheme();
  const scroll = useScroll();
  const tooltipWrapperRef = useRef(null);

  const {
    feeDetails,
    openFeeDetails,
    toggleOpenFeeDetails,

    buttonStyle,
  } = props;

  useEffect(() => {
    toggleOpenFeeDetails && toggleOpenFeeDetails(false);
  }, [scroll]);

  useOutsideClick(tooltipWrapperRef, () => {
    toggleOpenFeeDetails && toggleOpenFeeDetails(false);
  });
  return (
    <div>
      <style jsx global>
        {`
          div.setur-tooltip-content {
            margin-bottom: -5px;
            width: 184px;
          }

          .setur-tooltip-arrow {
            width: 20px !important;
            height: 20px !important;
          }
          .setur-tooltip-arrow-content {
            width: 100% !important;
            height: 100% !important;
            background-color: ${palette.darkGrey} !important;
          }
        `}
      </style>
      <FeeDetailsTooltip
        mouseEnterDelay={0.8}
        open={openFeeDetails}
        styles={{
          body: {
            backgroundColor: palette.darkGrey,
            borderRadius: '10px',
            padding: '10px',
            opacity: '1',
          },
        }}
        title={
          <div>
            <FeeDetailsItem>
              <span>{feeDetails?.title}</span>
              <span>
                {feeDetails?.subTotal}{' '}
                {getCurrencySymbol(
                  feeDetails?.originalCurrency || feeDetails?.currency
                )}
              </span>
            </FeeDetailsItem>

            {feeDetails?.taxAndFee ? (
              <FeeDetailsItem>
                <span>Vergiler ve Ücretler</span>
                <span>
                  {feeDetails.taxAndFee}{' '}
                  {getCurrencySymbol(
                    feeDetails?.originalCurrency || feeDetails?.currency
                  )}
                </span>
              </FeeDetailsItem>
            ) : null}

            <FeeDetailsItem style={{ fontWeight: 600 }}>
              <span>Toplam</span>
              <span>
                {feeDetails?.total.toFixed(2)}{' '}
                {getCurrencySymbol(
                  feeDetails?.currency || feeDetails?.originalCurrency
                )}
              </span>
            </FeeDetailsItem>
            <FeeDetailsDueHotelLabel>Otelde Ödenir</FeeDetailsDueHotelLabel>

            {feeDetails?.mandatoryTax ? (
              <FeeDetailsItem>
                <span>Şehir Vergisi </span>
                <span>
                  {feeDetails?.mandatoryTax}{' '}
                  {getCurrencySymbol(
                    feeDetails?.originalCurrency || feeDetails?.currency
                  )}
                </span>
              </FeeDetailsItem>
            ) : null}
          </div>
        }
        placement='topRight'
      >
        <FeeDetailsButton
          style={buttonStyle}
          ref={tooltipWrapperRef}
          onMouseEnter={() =>
            toggleOpenFeeDetails && toggleOpenFeeDetails(true)
          }
        >
          <Row>
            <CustomIcon icon={Info} fontSize={12} />
          </Row>
        </FeeDetailsButton>
      </FeeDetailsTooltip>
    </div>
  );
};

export default FeeDetails;
